var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 126.10196687125097 88.0429627613355",
    width: 126.10196687125097,
    height: 88.0429627613355,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 126.10196687125097,
    height: 88.0429627613355,
    fill: "#00000000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.89990234375 72.39998626708984) rotate(0 16.601032263750426 -31.199993133544922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.53 -3.93, 32.93 -13.2, 33.2 -23.6 C33.47 -34, 6.87 -55.93, 1.6 -62.4 M0 0 C5.53 -3.93, 32.93 -13.2, 33.2 -23.6 C33.47 -34, 6.87 -55.93, 1.6 -62.4",
    stroke: "#fff",
    strokeWidth: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.89990234375 72.39998626708984) rotate(0 16.601032263750426 -31.199993133544922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.24 -51.74 C17.29 -55.01, 10.34 -58.28, 1.6 -62.4 M24.24 -51.74 C19.32 -54.06, 14.4 -56.37, 1.6 -62.4",
    stroke: "#fff",
    strokeWidth: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.89990234375 72.39998626708984) rotate(0 16.601032263750426 -31.199993133544922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.09 -39.69 C8.87 -46.66, 5.65 -53.63, 1.6 -62.4 M12.09 -39.69 C9.81 -44.62, 7.53 -49.55, 1.6 -62.4",
    stroke: "#fff",
    strokeWidth: 4,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 60.999961853027344) rotate(0 31.699981689453125 8.52150045415408)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 14,
    fontFamily: "Inter",
    fontSize: "13.634400726646502px",
    fill: "#fff",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr"
  }, "Tap Here")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.6003534a4949ba46b2608c577e3916e2.svg";
export { ForwardRef as ReactComponent };